var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "col-md-6 col-lg-4 footer--news end"
  }, [_c('div', {
    staticClass: "footer--news-heading"
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('footer.nl_heading')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('footer.nl_heading2')))])]), _vm._v(" "), _c('div', {
    staticClass: "footer--news-cnt bg lazyload",
    attrs: {
      "data-bgset": _vm.background
    }
  }, [_c('div', [_c('h4', [_vm._v(_vm._s(_vm.$t('footer.nl_label')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('footer.nl_subheading')))]), _vm._v(" "), _c('div', {
    staticClass: "footer--news-form news-form"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.email,
      expression: "email"
    }],
    staticClass: "email",
    attrs: {
      "placeholder": _vm.$t('footer.nl_placeholder'),
      "aria-label": _vm.$t('footer.nl_placeholder'),
      "type": "email",
      "name": "newsletter-mail"
    },
    domProps: {
      "value": _vm.email
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.email = $event.target.value;
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-dark px-0",
    attrs: {
      "aria-label": _vm.$t('footer.nl_submit')
    },
    domProps: {
      "textContent": _vm._s(_vm.$t('footer.nl_submit'))
    },
    on: {
      "click": function click($event) {
        return _vm.submitEmail();
      }
    }
  })])])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };